import Gallery from "../component/Gallery";

export default function Farmers() {
  let $elemStep = document.querySelector(".step-by-step .field-content");
  Gallery($elemStep);
}
